import RequestOption from "./RequestOption";

const generateGUID = () => {
  let crypto = window.crypto || (window as any).msCrypto;
  if (!crypto) {
    console.log("Crypto API not supported");
    return Date.now().toString(16);
  }
  let buf = new Uint16Array(8);
  crypto.getRandomValues(buf);
  return (
    buf[0].toString(16) +
    buf[1].toString(16) +
    "-" +
    buf[2].toString(16) +
    "-" +
    buf[3].toString(16) +
    "-" +
    buf[4].toString(16) +
    "-" +
    buf[5].toString(16) +
    buf[6].toString(16) +
    buf[7].toString(16)
  );
};

class WatchedMap<K, V> extends Map<K, V> {
  private listeners: ((map: WatchedMap<K, V>) => void)[] = [];

  private notify() {
    this.listeners.forEach((fn) => fn(this));
  }

  watch(callback: (typeof this.listeners)[number]) {
    this.listeners.push(callback);
    callback(this);
  }

  unwatch(callback: (typeof this.listeners)[number]) {
    const idx = this.listeners.indexOf(callback);
    if (idx > -1) this.listeners.splice(idx, 1);
  }

  override set(key: K, value: V): this {
    super.set(key, value);
    this.notify();
    return this;
  }

  override delete(key: K): boolean {
    const result = super.delete(key);
    this.notify();
    return result;
  }

  override clear(): void {
    super.clear();
    this.notify();
  }
}

const globalPendingRequests = new WatchedMap<
  string,
  {
    requestPromise: Promise<any>;
    callbacks: RequestOption[];
  }
>();

export { generateGUID, globalPendingRequests };
